/**
 * packages/api-types/src/client.ts — the typed client factory every TypeScript
 * consumer uses (kiosk, admin SPA, bot). Dart consumers get the equivalent from
 * `openapi-generator-cli` (backend-spec.md §9.3).
 *
 * `gen/schema.d.ts` is GENERATED from contracts/openapi.yaml and must never be
 * hand-edited — CI regenerates it and fails on any diff (§1, drift control).
 */
import createClient, {} from 'openapi-fetch';
/**
 * Builds a typed client. Every request/response shape comes from the canonical
 * contract, so a contract change that breaks a consumer breaks its typecheck.
 */
export function createNavoiyClient(options) {
    const { baseUrl, bearerToken, deviceId, installId, allowInsecure, ...rest } = options;
    if (!allowInsecure && !baseUrl.startsWith('https://')) {
        throw new Error(`Refusing a plaintext API base URL: ${baseUrl}. backend-spec.md §10.3 pins the scheme to https.`);
    }
    const headers = {};
    if (bearerToken)
        headers.Authorization = `Bearer ${bearerToken}`;
    if (deviceId)
        headers['X-Device-Id'] = deviceId;
    if (installId)
        headers['X-Install-Id'] = installId;
    return createClient({ baseUrl, headers, ...rest });
}
/** Narrows an unknown error body to the §3.1 problem shape. */
export function isProblem(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'code' in value &&
        'status' in value &&
        'title' in value);
}
//# sourceMappingURL=client.js.map